import startDemoApp from "./demo-app";

const startApps = async () => {
    await startDemoApp();
};

void startApps();
